import React from "react";
import { useSearchParams } from "react-router-dom";

import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";

import NoteTab from "../../../Note/Notetab";
import EBillRefundTab from "./EBillRefundTab";

import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useGetShipmentRefundEBillsQuery } from "store/services/PaymentsApi/shipmentRefundApi";
import { useShipmentRefundDetailContext } from "contexts/PaymentContexts/ShipmentRefundDetailContext";


const ShipmentRefundDetailTab = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "note";

  const { shipmentRefundDetail } = useShipmentRefundDetailContext();

  // Fetch notes count
  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: "ShipmentRefund",
      sourceRef: shipmentRefundDetail?._id,
    },
    {
      skip: !shipmentRefundDetail?._id,
    }
  );
  const isCancellation = shipmentRefundDetail?.refundType?.name === "Cancellation";
  const isCodTransfer = Boolean(shipmentRefundDetail?.isTransferToCOD);
  const hasEBill = Boolean(shipmentRefundDetail?.eBillId || shipmentRefundDetail?.eBillInvoiceNo);
  const showEBillTab = isCancellation || isCodTransfer || hasEBill;

  const {
    data: ebills,
    isLoading: loadingEBills,
    isFetching: fetchingEBills,
  } = useGetShipmentRefundEBillsQuery(shipmentRefundDetail?._id, {
    skip: !shipmentRefundDetail?._id || !showEBillTab,
  });

  const tabs = [
    {
      label: "Note",
      value: "note",
      badgeCount: notes?.length || 0,
    },
    ...(showEBillTab
      ? [
        {
          label: "EBill",
          value: "ebill",
          badgeCount: ebills?.length || 0,
        },
      ]
      : []),
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {shipmentRefundDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab
              source="ShipmentRefund"
              sourceRef={shipmentRefundDetail?._id}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="ebill">
            <EBillRefundTab
              ebills={ebills}
              isLoading={loadingEBills}
              isFetching={fetchingEBills}
            />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default ShipmentRefundDetailTab;
